import { addDisplayName, addHandlers, flowMax } from 'ad-hok'
import { getContextHelpersFromInitialValues } from 'ad-hok-utils'
import { FC } from 'react'
import { addNavigationState } from 'shared/src/utils/addNavigationState'

export interface ShowMenuContext {
  showMenu: boolean
  setShowMenu: (show: boolean) => void
  toggleMenu: () => void
}

export const [addShowMenuContextProvider, addShowMenuContext] =
  getContextHelpersFromInitialValues<ShowMenuContext>({
    showMenu: false,
    setShowMenu: () => {},
    toggleMenu: () => {},
  })

export const MenuProvider: FC = flowMax(
  addDisplayName('MenuProvider'),
  addNavigationState('showMenu', 'setShowMenu', false),
  addHandlers({
    toggleMenu:
      ({ showMenu, setShowMenu }) =>
      () => {
        setShowMenu(!showMenu)
      },
  }),
  addShowMenuContextProvider,
  ({ children }) => <>{children}</>
)
